import { MainLocationAllocation } from '@horasys/bellplus/common/types';
export const getLocationFromJson = (json: any): MainLocationAllocation => {
	const mainLocation = {} as MainLocationAllocation;
	mainLocation.id = json.id;
	mainLocation.adEndTime = json.adEndTime;
	mainLocation.adPlaySchedule = json.adPlaySchedule;
	mainLocation.adStartTime = json.adStartTime;
	mainLocation.address = json.address;
	mainLocation.area = json.area;
	mainLocation.availableDevices = json.availableDevices;
	mainLocation.availableSlots = json.availableSlots;
	mainLocation.city = json.city;
	mainLocation.dailyFootFall = json.dailyFootFall;
	mainLocation.category = json.locationCategory;
	mainLocation.code = json.locationCode;
	mainLocation.description = json.locationDescription;
	mainLocation.movement = json.locationMovement;
	mainLocation.name = json.locationName;
	mainLocation.type = json.locationType;
	mainLocation.restrictedList = '';
	mainLocation.pincode = json.pinCode;
	mainLocation.pricePlanId = json.pricePlanId;
	mainLocation.propertyHolderId = json.propertyHolderId;
	mainLocation.rentPerDevice = json.rentPerDevice;
	mainLocation.state = json.state;
	mainLocation.totalDevices = json.totalDevices;
	mainLocation.totalResidential = json.totalResidential;
	mainLocation.totalSlots = json.totalSlots;
	mainLocation.noOfTimes = 0;
	mainLocation.selectedDevices = 0;
	mainLocation.added = false;
	if (json.locationAsset && json.locationAsset.url) {
		mainLocation.asset = json.locationAsset.url;
	}
	return mainLocation;
};
